import React from "react";

type FieldLabelProps = {
  children: React.ReactNode;
  htmlFor?: string;
  id?: string;
  popover?: React.ReactNode;
};

function FieldLabel({ children, htmlFor, id, popover }: FieldLabelProps): React.ReactElement {
  const label = (
    <label className="app-form-label" htmlFor={htmlFor} id={id}>
      {children}
    </label>
  );

  if (!popover) {
    return label;
  }

  return (
    <div className="app-form-label-with-popover">
      {label}
      {popover}
    </div>
  );
}

export default FieldLabel;
